var _style, _circle, _circle2, _path, _ellipse, _ellipse2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParentGuardian = function SvgParentGuardian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "parent-guardian_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 300 300"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".parent-guardian_svg__st9{fill:#366aff}.parent-guardian_svg__st12{fill:#ff9800}.parent-guardian_svg__st13{fill:#043673}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 150,
    className: "parent-guardian_svg__st12"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 150,
    className: "parent-guardian_svg__st12"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.3 211.7v78c16.9 6.6 35.4 10.3 54.7 10.3s37.7-3.6 54.7-10.3v-78H95.3",
    className: "parent-guardian_svg__st9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.3 211.7v42.1c12.3 18.1 30.4 25.6 54.7 25.6s42.4-7.5 54.7-25.6v-42.1z",
    style: {
      fill: "#224bbe"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3,
    cy: 179,
    className: "parent-guardian_svg__st9",
    rx: 18.3,
    ry: 22.3,
    transform: "rotate(-20.577 71.351 178.998)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.7,
    cy: 179,
    className: "parent-guardian_svg__st9",
    rx: 22.3,
    ry: 18.3,
    transform: "rotate(-69.421 228.656 178.972)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.7 157.5c0 57.1-25.4 105-78.7 105s-78.7-47.9-78.7-105S96.7 54.1 150 54.1s78.7 46.3 78.7 103.4",
    className: "parent-guardian_svg__st9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.7 221.8h-2.2c-13 0-25.9-3.1-37.5-9.1-11.6 6-24.4 9.1-37.5 9.1h-2.2v-20.2c0-6.9 5.7-12.6 12.6-12.6h54.2c6.9 0 12.6 5.7 12.6 12.6zM86.5 70.6s-.9-42.5 57-41.2c33.1.7 77.3 27.5 82-.2 0 0 34.3 57.4-45.9 64.6z",
    className: "parent-guardian_svg__st13"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9 72.2s-53.5-29.2-80.2 3c-12.2 14.7-4.2 49 1 81.7l12.3 11c8.4-17.2-6.8-24.5 7.1-60.1 14-35.6 37.5-4 62.6-4s48.6-31.6 62.6 4-1.2 43 7.1 60.1l9.2-10.3c16.3-55.1 5.9-66.9-5.5-79.9-25.2-28.8-76.2-5.5-76.2-5.5",
    className: "parent-guardian_svg__st13"
  })));
};
export default SvgParentGuardian;